// extracted by mini-css-extract-plugin
module.exports = {"totpQrcode":"Totp__totpQrcode___1crLx"};